<!--组织架构-->
<template>
    <div id="orgStrut">
        <bread :content="breadContent"></bread>
        <p class="Page-title">组织架构</p>
        <el-divider></el-divider>
        <img :src="imgSrc" class="image">
        <!--div-- class="time">最后编辑时间：{{ editTime }}</!--div-->
    </div>
</template>
<script>
import bread from '@/components/bread'
export default {
  name: "orgStrut",
  components:{
      bread,
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "中心概况", routerName: "introduce" },
        { text: "组织架构", routerName: "orgStrut" }
      ],
      imgSrc: '',
      editTime: ''
    }
  },
  async created() {
    const res = await this.$net.introduce.getStructure()
    this.imgSrc = res.Content
    this.editTime = res.AdminSetTime
  }
}
</script>
  
<style scoped>
#orgStrut {
  display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
.image {
  width: 100%;
}
.time {
  margin-top: 60px;
  color: #909399;
  text-align: right;
}
</style>
